import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { kendoPopupZIndex } from 'styles/variables';

export const FullScreenPopupContent = styled.div<{ $noPadding: boolean }>`
    z-index: ${kendoPopupZIndex};
    background: ${tokens.background.paperElevation8};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
`;

export type PopupContentProps = Readonly<{
    $noPadding: boolean;
}>;

/**
 * CSS custom property, set on the floating element, holding the vertical space
 * (px) available to the popup on its placed side of the anchor.
 */
export const AvailableHeightVar = '--triggered-popup-available-height';

export const PopupContentWrapper = styled.div`
    z-index: ${kendoPopupZIndex};
    border-radius: 0.5rem;
    box-shadow: ${tokens.elevation['200']};
    border: ${tokens.popup.border};
    position: relative;
    box-sizing: border-box;
    max-height: var(${AvailableHeightVar}, none);
    display: flex;
    flex-direction: column;
`;

export const PopupContent = styled.div<PopupContentProps>`
    border-radius: 0.5rem;
    min-height: 0;
    overflow-y: auto;
    background: ${tokens.background.paperElevation8};
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
    position: relative;
`;
